import { validateFieldsArrayForFinalForm } from '@/Framework/UI/Organisms/FinalForm/validators/validateFieldsArrayForFinalForm';
import {
  PORTFOLIO_OPTIONAL_DATA_FIELD_ARRAY,
} from '@/finsight/ui/components/portfolioMonitor/PortfolioContent/PortfolioForm/FormSteps/OptionalData/constants';
import { validateNumberMaxMinAmount } from '@/Framework/UI/Organisms/FinalForm/validators/validateNumberMaxMinAmount';
import { validateNumberWithDecimals } from '@/Framework/UI/Organisms/FinalForm/validators/validateNumberWithDecimals';
import { IValidationError } from '@/Framework/UI/Organisms/FinalForm/validators/interfaces/ValidationError';
import { removeDelimiters } from '@/Framework/dataHelpers/convertTypes';

interface IParams {
  value: number | string,
  fieldName: string,
  fieldCaption: string,
  maxAmount?: number,
  minAmount?: number,
}

type TValidate = (params: IParams) => IValidationError;

const MAX_INT_32 = 2147483647;

const validatePositionSizeWrapper = (params: IParams, validate: TValidate) => {
  if (!params.value) {
    return validate(params);
  }

  let newPositionSize = String(removeDelimiters(params.value, /,/g));
  const decimals = String(params.value).split('.')[1];
  if (decimals) {
    newPositionSize += Number(decimals) === 0 ? '.0' : '';
  }

  const newParams = {
    ...params,
    value: newPositionSize,
  };

  return validate(newParams);
};

const paramsPositions = [
  {
    fieldName: 'positionSize',
    fieldCaption: 'Position Size',
    functionValidation: [
      {
        name: (params) => validatePositionSizeWrapper(params, validateNumberWithDecimals),
        params: {
          maxDecimals: 0,
        },
      },
      {
        name: (params) => validatePositionSizeWrapper(params, validateNumberMaxMinAmount),
        params: {
          minAmount: 0,
          maxAmount: MAX_INT_32,
        },
      },
    ],
  },
  {
    fieldName: 'dollarPricePaid',
    fieldCaption: 'Dollar Price Paid',
    functionValidation: [
      {
        name: validateNumberMaxMinAmount,
        params: {
          minAmount: 0,
          maxAmount: 1000,
        },
      },
      {
        name: validateNumberWithDecimals,
        params: {
          maxDecimals: 5,
        },
      },
    ],
  },
];

export const validate = (values) => validateFieldsArrayForFinalForm(
    PORTFOLIO_OPTIONAL_DATA_FIELD_ARRAY,
    paramsPositions,
    { collection: values[PORTFOLIO_OPTIONAL_DATA_FIELD_ARRAY] },
);
